let basket_ajax = require( './basket-ajax' );
let forms = require( './forms' );

let order_review = (function( $ ) {

	let $review;

	let _init = function() {
		$review = $( '#crate-order-review' );

		if ( $review.length > 0 ) {
			_setup_remove_basket_items();
			_setup_remove_donation_items();

			$( document ).on( 'basket_item_removed', update_order_review_html );
		}
	};

	let _setup_remove_basket_items = function() {
		let $remove = $review.find( 'a.remove-item, button.remove-item' );

		$remove.on( 'click', function( e ) {
			e.preventDefault();

			let item_id = $( this ).data( 'item-id' );

			if ( item_id ) {
				basket_ajax.remove_item( item_id );
			}
		} );
	};

	let _setup_remove_donation_items = function() {
		let $remove = $review.find( 'a.remove-donation' );

		console.log( $remove );

		$remove.on( 'click', _remove_donation );
	};

	let _remove_donation = function( e ) {
		e.preventDefault();

		forms.show_spinner( $( '#donation_form' ) );

		let data = {
			action: 'crate_remove_donation',
			nonce: ScriptData.crate_remove_donation_nonce
		};

		$.post( ScriptData.ajaxurl, data, _remove_donation_response );
	};

	let _remove_donation_response = function( response ) {
		if ( response.success ) {
			update_order_review_html();
		}
	};

	let update_order_review_html = function() {
		forms.show_spinner( $( '#donation_form' ) );

		let data = {
			action: 'crate_update_order_review',
			nonce: ScriptData.crate_update_order_review_nonce
		};

		console.log( data );

		$.get( ScriptData.ajaxurl, data, _update_order_review_html_response );
	};

	let _update_order_review_html_response = function( response ) {
		if ( typeof response.html === 'undefined' ) {
			return;
		}

		$review.replaceWith( response.html );
		$review = $( '#crate-order-review' );

		_setup_remove_basket_items();
		_setup_remove_donation_items();

		forms.hide_spinner( $( '#donation_form' ) );
	};

	$( document ).ready( _init );

	return {
		update_order_review_html: update_order_review_html
	};

})( jQuery );

module.exports = order_review;